export const WIDGET_MODES = {
  Playground: 'PLAYGROUND',
  Widget: 'WIDGET',
  AiStore: 'AI_STORE',
  Preview: 'PREVIEW',
} as const

export const DISPLAY_STATUSES = {
  Closed: 'closed',
  Open: 'open',
  Maximized: 'maximized',
} as const

export const CHAT_STATUSES = {
  Unread: 'unread',
  Responding: 'responding',
  Read: 'read',
} as const

export const LOCALES = ['es-AR', 'es-ES', 'en-US', 'en-GB', 'pt-BR', 'pt-PT', 'de-DE'] as const
